import { render, staticRenderFns } from "./SubscriberPlan.vue?vue&type=template&id=5b59f352"
import script from "./SubscriberPlan.vue?vue&type=script&lang=js"
export * from "./SubscriberPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports